export default __webpack_public_path__ + "static/media/consulta.5525891e.svg";